export default __webpack_public_path__ + "static/media/card_view_icon_disabled.e635a8e9.svg";